import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// "Are you sure?" step in front of a delete, so a stray tap on a trash icon
// can't wipe a record. Open while `target` is set:
// { title, description, confirmLabel?, onConfirm }.
export function ConfirmDelete({ target, onClose }) {
  return (
    <AlertDialog open={!!target} onOpenChange={(o) => { if (!o) onClose(); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{target?.title}</AlertDialogTitle>
          <AlertDialogDescription>{target?.description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="btn-cancel-delete">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="btn-confirm-delete" className="bg-rose-600 hover:bg-rose-700"
            onClick={() => { target?.onConfirm(); onClose(); }}>{target?.confirmLabel || "Delete"}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
